import { RouteLocationRaw, RouteRecordRaw } from 'vue-router';
import { StateKey } from '@/components/types';

export enum ITabsState {
  sign = 'sign',
  tiny = 'tiny',
  quaternary = 'quaternary'
}

type TabState = StateKey | keyof typeof ITabsState;

export type ITab<T extends string = string> = {
  key: T;
  id?: string;
  to?: Partial<RouteRecordRaw|RouteLocationRaw>;
  exact?: boolean;
  icon?: string;
  disabled?: boolean;
  onClick?(event: MouseEvent): void;
  label: string;
}

export type ITabs<T extends string = string> = {
  state?: ITabsState | Array<ITabsState> | Array<TabState>;
  tabs: Array<ITab<T>>;
  tabsState?: Record<T, 'string'>;
  modelValue?: ITab<T>['key'];
}
